/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import { CLIENT_PUBLIC_TOKEN }         from '../config.js'
import Grid                            from "@material-ui/core/Grid"
import { node_server }                 from '../Helpers/index.js'
import PropTypes                       from 'prop-types'
import Typography                      from "@material-ui/core/Typography"
import ModalComponent                  from './ModalComponent.js'
import ShowHistoryPhoto                from './ShowHistoryPhoto.js'

const HistoryEntries = () => {

   const [ id,             setId                ]  =  useState('')
   const [ isOpen,         setIsOpen            ]  =  useState(false)
   const [ displayEntries,  setDisplayEntries   ]  =  useState([])

   const handleModal = ( id ) => {
      setId(id)
      setIsOpen(true)
   }

   const closeModal = () => {
      setIsOpen(false)
   }

   /* This shows the available Historical Entries from the history collection in MongoDB. */
   useEffect(() => {
      console.log('HistoryEntries useEffect is running')
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'history/')
         .then( res => res.data )
         .then( data => {
            // console.log('<HistoryEntries /> are', data)
            setDisplayEntries(data.map( d => {
               // console.log('<HistoryEntries /> id and _id are', id, d._id)
               // console.log('<HistoryEntries entries are', d)
               return(
               <Grid key={d._id} >
                  <Typography key={d._id} variant='h5' align='left' style={{ marginBottom: '5px', marginTop: '5px' }} >
                     { d.title }
                  </Typography>
                  {d.entries.length > 0
                     ?
                        d.entries.map( (e, i) => {
                           if (e.entryType === 'text') {
                              return(
                                 <Typography key={d._id + i} style={{ textAlign: 'left', marginBottom: '10px' }} >
                                    { e.entry }
                                 </Typography>
                              )
                           }
                           else if(e.entryType === 'bullet') {
                              return(
                                 <Typography key={d._id + i} style={{ textAlign: 'left', marginBottom: '10px', marginLeft: '20px' }} >
                                    { e.entry }
                                 </Typography>
                              )
                           }
                           else if(e.entryType === 'photo') {
                              return(
                                 <Grid key={e._id + i} >
                                    <ShowHistoryPhoto entry={e} />
                                 </Grid>
                              )
                           }
                           return null
                        } )
                     :
                        null
                  }
                  {d.links.length > 0
                     ?
                        d.links.map( (link, i) => {
                           return(
                              <Typography key={link._id + i} variant='h6' style={{ textAlign: 'left', marginBottom: '10px', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleModal(link.id)} >
                                 { link.caption }
                              </Typography>
                           )
                        })
                     :
                        null
                  }
               </Grid>
               )
            }))
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )
   }, [] )

   return (
      <Box>
         <Grid style={{ marginTop: '6rem', padding: '2rem' }} >
            { displayEntries }
         </Grid>
         { isOpen ? <ModalComponent closeModal={closeModal} id={id} /> : null }
      </Box>
   )
}

HistoryEntries.propTypes = {
  page:        PropTypes.string
}

export default HistoryEntries
